import React, { useState, useEffect, useRef, useContext } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, makeStyles, Slide } from "@material-ui/core";
import { Theme } from '../contexts/themeContext.js';
import { GlobalTheme } from "../../layouts/theme";
let timerInterval = null;

const useStyles = makeStyles(() => ({
    dialog: {
        borderRadius: 0
    },
    button: {
        borderRadius: 0,
        textTransform: "none",
        padding: 5
    },
    timerTime: {
        color: 'red',
        fontWeight: 'bold'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TimerDialog = (props) => {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const currentTheme = GlobalTheme[theme];
    const [remainingTime, setRemainingTime] = useState(props.initialRemainingTime - 1);
    const timerRef = useRef(null);

    const clearTimerInterval = () => {
        clearInterval(timerInterval);
        props.onClose();
    };

    useEffect(() => {
        timerInterval = setInterval(() => {
            if (timerRef.current)
                timerRef.current = timerRef.current - 1;
            else
                timerRef.current = props.initialRemainingTime - 2;
            setRemainingTime(timerRef.current);

            if (timerRef.current === 0) {
                clearTimerInterval();
            }
        }, 1000);

        return () => {
            clearInterval(timerInterval);
        };
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog
            open={props.open}
            classes={{ paper: classes.dialog }}
            TransitionComponent={Transition}>
            <DialogTitle className={classes.timerTime}>Alert!</DialogTitle>
            <DialogContent>
                <Typography variant="body2"><span className={classes.timerTime}>{remainingTime}</span>{remainingTime > 9 ? ' seconds' : ' second'} {' remaining to update the observation. Please complete your observation.'}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={clearTimerInterval} className={classes.button} variant="contained" color="primary" size="small" style={{ background: currentTheme.secondary, width: "50px", marginRight: "10px" }} autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TimerDialog;
